import React from "react";
import { Form, Input, Select } from "antd";

const PriceAndUnitsTab: React.FC<{
  colorOptions: any[];
  measureOptions: any[];
  costOptions: any[];
  vendorOptions: any[];
  unitsOptions: any[];
}> = ({
  colorOptions,
  measureOptions,
  costOptions,
  vendorOptions,
  unitsOptions,
}) => {
  return (
    <div className="grid grid-cols-3 gap-3">
      <Form.Item name="ColorID" label="اللون">
        <Select options={colorOptions} />
      </Form.Item>
      <Form.Item name="MeagureID" label="وحدة القياس">
        <Select options={measureOptions} />
      </Form.Item>
      <Form.Item name="CostId" label="نوع التكلفة">
        <Select options={costOptions} />
      </Form.Item>
      <Form.Item name="ProductCost" label="تكلفة المنتج">
        <Input type="number" />
      </Form.Item>
      <Form.Item name="MainUnitId" label="الوحدة الرئيسية">
        <Select options={unitsOptions} />
      </Form.Item>
      <Form.Item name="SubUnitId" label="الوحدة الفرعية">
        <Select options={unitsOptions} />
      </Form.Item>
      <Form.Item name="MainUnitPrice" label="سعر الوحدة الرئيسية">
        <Input type="number" />
      </Form.Item>
      <Form.Item name="SubUnitPrice" label="سعر الوحدة الفرعية">
        <Input type="number" />
      </Form.Item>
      <Form.Item name="GomlaPrice" label="سعر الجملة">
        <Input type="number" />
      </Form.Item>
      <Form.Item name="VendorId" label="المورد">
        <Select options={vendorOptions} />
      </Form.Item>
      <Form.Item name="Notes" label="ملاحظات">
        <Input.TextArea rows={3} />
      </Form.Item>
    </div>
  );
};

export default PriceAndUnitsTab;
